import React from 'react'

import type { IconNames } from '@gousto-internal/citrus-react'
import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  Icon,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { Svg } from 'components/Svg/Svg'

type LocalIconName = 'spiceHot' | 'spiceMedium' | 'spiceMild' | 'spiceNone'

type RecipeAttributePillProps =
  | {
      variant?: 'none'
      text: string
    }
  | {
      variant?: 'citrus'
      icon: IconNames
      text: string
    }
  | {
      variant: 'local'
      localIcon: LocalIconName
      text: string
    }

const localIconToSvgName: Record<LocalIconName, string> = {
  spiceHot: 'icon-spice-hot',
  spiceMedium: 'icon-spice-medium',
  spiceMild: 'icon-spice-mild',
  spiceNone: 'icon-spice-none',
}

const Pill = withCitrusTheme(Box, (theme) => ({
  borderRadius: theme.spacing(10),
  width: 'fit-content',
  margin: '4px 4px 4px 0px',
}))

const BodyText = withCitrusTheme(Body2, () => ({
  whiteSpace: 'nowrap',
}))

const LocalIcon = withCitrusTheme(Svg, () => ({
  backgroundPosition: 'center',
  width: '32px',
  height: '24px',
}))

const renderIcon = (props: RecipeAttributePillProps) => {
  if (props.variant === 'local') {
    return <LocalIcon fileName={localIconToSvgName[props.localIcon]} hidden className="" label="" />
  }

  if ('icon' in props) {
    return <Icon name={props.icon} />
  }

  return null
}

export const RecipeAttributePill = (props: RecipeAttributePillProps) => {
  const { text } = props as Partial<RecipeAttributePillProps>

  return (
    <Pill
      display={Display.Flex}
      alignItems={AlignItems.Center}
      bg={Color.NeutralGrey_50}
      justifyContent={JustifyContent.SpaceEvenly}
      paddingV={1}
      paddingH={2}
      data-testid="recipe-attribute-pill"
      gap={2}
    >
      {renderIcon(props)}
      <BodyText size={1} color={Color.ColdGrey_900}>
        {text}
      </BodyText>
    </Pill>
  )
}
